import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Radio, ControlLabel, HelpBlock, Alert } from 'react-bootstrap'
import questionTypes from '../questionTypes.json'

MultipleChoiceQuestion.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  onAnswer: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string,
  help: PropTypes.string
}

function MultipleChoiceQuestion({
  questionId,
  text,
  options,
  onAnswer,
  answers,
  readOnly,
  showValidation,
  validationState = null,
  help
}) {
  let newValidationStateToShow = showValidation ? validationState : null

  const selectedAnswersIds = answers.map(answer => answer.answerId)
  return (
    <FormGroup validationState={newValidationStateToShow}>
      <ControlLabel>{text}</ControlLabel>
      {!readOnly && options.map((option, index) => {
        return <Radio key={index}
          name={questionId}
          onClick={() => {
            onAnswer(questionId, questionTypes.multipleChoice, option.answerId, true)
          }}
          checked={selectedAnswersIds.indexOf(option.answerId) > - 1}>
          {option.text}
        </Radio>
      })}
      {readOnly && options.map((option, index) => {
        if (selectedAnswersIds.indexOf(option.answerId) > - 1) {
          return <Radio key={index}
            name={questionId}
            disabled
            checked >
            {option.text}
          </Radio>
        }
        return ''
      })}
      {help && showValidation && <HelpBlock>
        <Alert bsStyle='danger'>
          {help}
        </Alert>
      </HelpBlock>}
    </FormGroup>)
}

export default MultipleChoiceQuestion



// WEBPACK FOOTER //
// ./src/components/questions/MultipleChoiceQuestion/MultipleChoiceQuestion.js